import { Checkbox, Spin } from "antd";
import React from "react";
import { TTranslate } from "../../../../core/service/locale/TranslationService";
import { IOrganisation } from "../../../../organisations/model/Organisation";
import { TFacet } from "../../../model/SearchResponse";

export interface Props {
  translate: TTranslate;
  loading?: boolean;
  selectedOrganisations?: string[];
  organisations?: IOrganisation[];
  onChange?(list: string[]): any;
  organisationFacets?: TFacet;
  showFacetCount?: boolean;
  horizontal?: boolean;
}

export default function OrganisationCheckboxGroup({
  translate,
  loading = false,
  selectedOrganisations,
  organisations,
  onChange,
  organisationFacets,
  showFacetCount = false,
  horizontal = false
}: Props) {
  return (
    <Spin spinning={loading || false}>
      <Checkbox.Group
        className={horizontal ? "png-checkbox-group-horizontal" : ""}
        value={selectedOrganisations}
        onChange={(list) => onChange?.(list.map((item) => item.toString()))}
      >
        {organisations?.map((item, index) => {
          let label = item.name;
          if (showFacetCount) {
            label += ` (${organisationFacets?.[item.name] || "0"})`;
          }
          return (
            <div style={{ marginBottom: 4 }} key={`org-check-${index}`}>
              <Checkbox key={`org-check-${index}`} value={item.id.toString()}>
                {label}
              </Checkbox>
            </div>
          );
        })}
      </Checkbox.Group>
    </Spin>
  );
}
